import type { PaginationProps, TablePaginationConfig } from 'antd'
import { PAGE_SIZE } from '../../api'

const paginationLocale = {
  items_per_page: '条/页',
}

type TablePaginationOptions = {
  pageSize?: number
  showSizeChanger?: boolean
  pageSizeOptions?: string[]
}

type ListPaginationOptions = {
  pageSize?: number
  unit?: string
  showSizeChanger?: boolean
  pageSizeOptions?: string[]
}

/** 服务端分页 Table 统一配置 */
export function tablePagination(
  page: number,
  total: number,
  onChange: (page: number, pageSize: number) => void,
  options?: TablePaginationOptions,
): TablePaginationConfig {
  const pageSize = options?.pageSize ?? PAGE_SIZE
  return {
    current: page,
    pageSize,
    total,
    showTotal: (t) => `共 ${t} 条`,
    showSizeChanger: options?.showSizeChanger ?? true,
    pageSizeOptions: options?.pageSizeOptions ?? ['10', '20', '50', '100'],
    locale: paginationLocale,
    onChange: (p, ps) => onChange(p, ps ?? pageSize),
    onShowSizeChange: (_p, ps) => onChange(1, ps),
  }
}

/** 非 Table 列表（卡片、检索结果等）统一分页 */
export function listPagination(
  page: number,
  total: number,
  onChange: (page: number, pageSize: number) => void,
  options?: ListPaginationOptions,
): PaginationProps {
  const pageSize = options?.pageSize ?? PAGE_SIZE
  const unit = options?.unit ?? '条'
  return {
    current: page,
    pageSize,
    total,
    showTotal: (t) => `共 ${t} ${unit}`,
    showSizeChanger: options?.showSizeChanger ?? true,
    pageSizeOptions: options?.pageSizeOptions ?? ['10', '20', '50', '100'],
    locale: paginationLocale,
    onChange: (p, ps) => onChange(p, ps ?? pageSize),
    onShowSizeChange: (_p, ps) => onChange(1, ps),
  }
}
